import { createFileRoute, redirect, Outlet } from '@tanstack/react-router'
import { getUser } from '@/utils/auth'

export const Route = createFileRoute('/_public')({
  beforeLoad: () => {
    const user = getUser()
    if (user) {
      throw redirect({ to: '/' })
    }
  },
  component: Outlet,
})
